module.exports = __webpack_public_path__ + "static/praise-96dea3bd2b171f22b60ad3b5fcaba32e.jpg";